/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from 'react';
import style from './transaction.module.css';
import { Table, Input, Pagination, Space, Dropdown, Checkbox, Tag, message, Upload, Button } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import { CiMenuKebab, CiFilter, CiSearch } from 'react-icons/ci';
import ButtonP from '../../components/Basic/button';
import FormModal from '../../components/Modal/FormModal';
import Features from '../Features/Features'
import Image from '../../Images/profile_image.png'
import * as XLSX from 'xlsx';
import { CiImport, CiExport } from "react-icons/ci";
import Header from '../../components/Header/header';
import { Select } from 'antd';
import * as Action from '../../store/slices/transaction/transaction'
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';

interface Api {
    getTransaction: (params: any) => void;
    getUploadedFiles: () => Promise<any>;
    Transaction_Red: any;
}


interface DataSource {
    key: string;
    ReferenceID: string;
    Type: string;
    From: string;
    To: string;
    Status: string;
    Date: string;
    Time: string;
    Amount: string;
}

const MultiViewTable: React.FC<Api> = ({ getTransaction, getUploadedFiles, Transaction_Red }) => {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(9);
    const [uploadedFiles, setUploadedFiles] = useState<{ id: number; name: string }[]>([]);
    const [selectedColumns, setSelectedColumns] = useState<string[]>(['ReferenceID', 'Type', 'From', 'To', 'Status', 'Date', 'Time', 'Amount', 'Name']);
    const [loadingText, setLoadingText] = useState<boolean>(true)
    const [buttonLoading, setButtonLoading] = useState<boolean>(false);
    const [open, setOpen] = useState(false);
    const [showForm, setShowForm] = useState<boolean>(false);
    const [modalText, setModalText] = useState<string>('');
    const [tableData, setTableData] = useState<DataSource[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [searchText, setSearchText] = useState("");           // optional client-side
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [filters, setFilters] = useState({
        fromDate: undefined as string | undefined,
        toDate: undefined as string | undefined,
        minTrxAmount: 0,
        maxTrxAmount: 0,
        customerIdentifier: "",
        branchIdentifier: "",
        accountShortName: "",
        fileId: undefined as number | undefined,
    });



    useEffect(() => {
        const timer = setTimeout(() => setDebouncedSearch(searchText), 500);
        return () => clearTimeout(timer);
    }, [searchText]);

    useEffect(() => {
        getUploadedFiles().then((res: any) => {
            if (res?.success && Array.isArray(res?.data)) {
                setUploadedFiles(res.data.map((f: any) => ({ id: f.fileId, name: f.fileName })));
            }
        });
    }, []);



    console.log(Transaction_Red?.data?.[0]?.res?.data?.content, 'transaction')


    useEffect(() => {
        fetchTransactions(currentPage, pageSize);
    }, [currentPage, pageSize, debouncedSearch, filters]);

    const fetchTransactions = (page: number, size: number) => {
        setLoadingText(true);

        const params = {
            page: page - 1,
            size,
            fromDate: filters.fromDate,
            toDate: filters.toDate,
            minTrxAmount: filters.minTrxAmount,
            maxTrxAmount: filters.maxTrxAmount,
            customerIdentifier: filters.customerIdentifier || undefined,
            branchIdentifier: filters.branchIdentifier || undefined,
            accountShortName: filters.accountShortName || undefined,
            fileId: filters.fileId,
        };

        const cleanParams: any = Object.fromEntries(
            Object.entries(params).filter(([_, v]) => v !== "" && v !== undefined && v !== 0)
        );

        getTransaction(cleanParams);
    };



    useEffect(() => {
        const res = Transaction_Red?.data?.[0]?.res?.data;

        if (res?.content) {
            const mapped = res.content.map((item: any) => ({
                key: item.transactionId,
                ReferenceID: item.bankTransactionId,
                Type: item.accountShortName || "-",
                From: item.customerIdentifier || "-",
                To: item.branchIdentifier || "-",
                Status: "Active",
                Date: item.transactionDate
                    ? new Date(item.transactionDate).toLocaleDateString("en-GB")
                    : "-",
                Time: item.transactionDate
                    ? new Date(item.transactionDate).toLocaleTimeString("en-US", {
                        hour: "2-digit",
                        minute: "2-digit",
                    })
                    : "-",
                Amount: item.transactionAmount != null ? `OMR ${item.transactionAmount}` : "-",
            }));

            setTableData(mapped);
            setTotal(res.totalElements || 0);
            setLoadingText(false);
        } else if (Transaction_Red?.dataSingle?.[0]?.res?.status === '1004') {
            message.error(Transaction_Red.dataSingle[0].res.message);
            localStorage.clear();
            navigate('/');
        } else if (Transaction_Red?.dataSingle?.[0]?.res?.status === '1005') {
            message.warning(Transaction_Red.dataSingle[0].res.message);
            setTableData([]);
            setTotal(0);
            setLoadingText(false);
        } else if (Transaction_Red?.data?.[0]?.res) {
            setLoadingText(false);
            message.error("Failed to load transactions");
        }
    }, [Transaction_Red, navigate]);


    const onSearch = (value: string) => setSearchText(value.toLowerCase());

    const handleCheckboxChange = (checked: boolean, column: string) => {
        setSelectedColumns((prevSelected) =>
            checked ? [...prevSelected, column] : prevSelected.filter((col) => col !== column)
        );
    };



    const Addhandle = () => {
        setShowForm(true);
    };




    const Backhandle = () => {
        setShowForm(false); // Show the table and hide the form
    };




    const handleOpen = () => {
        setModalText('Are you sure you want to delete this record?');
        setOpen(true);
    }




    const actionMenu = (
        <Space direction="vertical" className={style.actions}>
            <div className={style.dropdownItem}>Edit</div>
            <div className={style.dropdownItem} onClick={handleOpen}>Delete</div>
        </Space>
    );




    const allColumns = [
        {
            title: 'Transaction ID',
            dataIndex: 'ReferenceID',
            key: 'ReferenceID',
            width: 150,
            sorter: (a: DataSource, b: DataSource) => {
                if (!a.ReferenceID || !b.ReferenceID) return 0;
                return a.ReferenceID.localeCompare(b.ReferenceID);
            },
        },
        // {
        //     title: 'Transaction Type',
        //     dataIndex: 'Type',
        //     key: 'Type',
        //     width: 150,
        //     sorter: (a: DataSource, b: DataSource) => a.Type.localeCompare(b.Type),
        // },
        {
            title: 'Customer Identifier',
            dataIndex: 'From',
            key: 'From',
            width: 100,
            sorter: (a: DataSource, b: DataSource) => {
                if (!a.From || !b.From) return 0;
                return a.From.localeCompare(b.From);
            },
        },

        {
            title: 'Date',
            dataIndex: 'Date',
            key: 'Date',
            width: 100,
            sorter: (a: DataSource, b: DataSource) => {
                if (!a.Date || !b.Date) return 0;
                return a.Date.localeCompare(b.Date);
            },
        },
        {
            title: 'Time',
            dataIndex: 'Time',
            key: 'Time',
            width: 100,
            sorter: (a: DataSource, b: DataSource) => {
                if (!a.Time || !b.Time) return 0;
                return a.Time.localeCompare(b.Time);
            },
        },
        {
            title: 'Amount',
            dataIndex: 'Amount',
            key: 'Amount',
            width: 100,
            sorter: (a: DataSource, b: DataSource) => {
                if (!a.Amount || !b.Amount) return 0;
                return a.Amount.localeCompare(b.Amount);
            },
        },

        {
            title: 'Status',
            dataIndex: 'Status',
            key: 'Status',
            width: 100,
            sorter: (a: DataSource, b: DataSource) => {
                if (!a.Status || !b.Status) return 0;
                return a.Status.localeCompare(b.Status);
            },
            render: (Status: string) => {
                const color = Status === "Active" ? "cyan" : Status === "Pending" ? "yellow" : "red";
                return (
                    <Tag style={{ marginInlineEnd: 0 }} color={color}>
                        {Status.toUpperCase()}
                    </Tag>
                )

            },
        },
        // {
        //     title: 'Action',
        //     key: 'action',
        //     fixed: 'right' as const,
        //     width: 50,
        //     render: () => (
        //         <Dropdown
        //             overlay={actionMenu}
        //             trigger={['click']}
        //             placement="bottomRight"
        //         >
        //             <CiMenuKebab className={style.actionIcon} />
        //         </Dropdown>
        //     ),
        // },
    ];





    const filteredColumns = allColumns.filter((col) => selectedColumns.includes(col.key) || col.key === 'action');

    const filteredData = tableData.filter((item) =>
        Object.values(item).some((val) =>
            val.toString().toLowerCase().includes(searchText)
        )
    );

    const items = [
        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('Type')}
                    value={'Type'}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'Type')}
                >
                    Type
                </Checkbox>
            ),
            key: '1',
        },
        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('ReferenceID')}
                    value={'ReferenceID'}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'ReferenceID')}
                >
                    Reference ID
                </Checkbox>
            ),
            key: '2',
        },
        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('From')}
                    value={'From'}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'From')}
                >
                    From
                </Checkbox>
            ),
            key: '3',
        },
        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('To')}
                    value={'To'}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'To')}
                >
                    To
                </Checkbox>
            ),
            key: '4',
        },
        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('Status')}
                    value={'Status'}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'Status')}
                >
                    Status
                </Checkbox>
            ),
            key: '5',
        },
        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('Date')}
                    value={'Date'}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'Date')}
                >
                    Date
                </Checkbox>
            ),
            key: '6',
        },
        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('Time')}
                    value={'Time'}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'Time')}
                >
                    Time
                </Checkbox>
            ),
            key: '7',
        },
        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('Amount')}
                    value={'Amount'}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'Amount')}
                >
                    Amount
                </Checkbox>
            ),
            key: '8',
        },

    ];





    useEffect(() => {
        setLoadingText(true)
        setTimeout(() => {
            setLoadingText(false)
        }, 2000)
    }, [])






    const handleExport = async () => {
        setButtonLoading(true);
        message.loading('Fetching all data for export...', 0);

        try {
            const token = localStorage.getItem('loginToken');
            if (!token) {
                message.destroy();
                message.error('Not authenticated. Please login.');
                setButtonLoading(false);
                return;
            }

            const apiUrl = process.env.REACT_APP_API_URL;
            const query = '?page=0&size=100000';
            const resp = await fetch(`${apiUrl}/api/trx${query}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            if (resp.status !== 200) {
                const err = await resp.json().catch(() => ({}));
                message.destroy();
                message.error(err.message || 'Failed to fetch data for export');
                setButtonLoading(false);
                return;
            }

            const { content = [] } = await resp.json().then((r: any) => r?.data || r) ;

            const allData = content || [];

            if (allData.length === 0) {
                message.destroy();
                message.warning('No data to export!');
                setButtonLoading(false);
                return;
            }

            const mappedData = allData.map((item: any) => ({
                ReferenceID: item.bankTransactionId,
                From: item.customerIdentifier || '-',
                Date: item.transactionDate
                    ? new Date(item.transactionDate).toLocaleDateString('en-GB')
                    : '-',
                Time: item.transactionDate
                    ? new Date(item.transactionDate).toLocaleTimeString('en-US', {
                          hour: '2-digit',
                          minute: '2-digit',
                      })
                    : '-',
                Amount: item.transactionAmount != null ? `OMR ${item.transactionAmount}` : '-',
                Status: 'Active',
            }));

            const csvContent = [
                ['Transaction ID', 'Customer Identifier', 'Date', 'Time', 'Amount', 'Status'],
                ...mappedData.map((item: any) => [
                    item.ReferenceID || '',
                    item.From || '',
                    item.Date || '',
                    item.Time || '',
                    item.Amount || '',
                    item.Status || '',
                ]),
            ]
                .map((row) => row.map((cell :any) => `"${String(cell).replace(/"/g, '""')}"`).join(','))
                .join('\n');

            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', `all_transaction_data_${new Date().toISOString().split('T')[0]}.csv`);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            message.destroy();
            message.success(`All ${allData.length} transactions exported successfully!`);
            setButtonLoading(false);

            // Refresh table data to original pagination
            fetchTransactions(currentPage, pageSize);
        } catch (error) {
            message.destroy();
            message.error('Failed to export data. Please try again.');
            setButtonLoading(false);
        }
    };


    

    const handleUpload = (file: File) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const binaryStr = e.target?.result;
            const workbook = XLSX.read(binaryStr, { type: 'binary' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const data = XLSX.utils.sheet_to_json(worksheet);

            console.log("Uploaded Data:", data);
            message.success("File uploaded and processed successfully!");
        };
        reader.readAsBinaryString(file);

        return false; // Prevent default upload behavior
    };

    const uploadProps = {
        beforeUpload: handleUpload,
        accept: ".xlsx,.csv",
    };





    return (
        <div className={style.sroll}>
            <Header />
            <FormModal modalTitle={modalText} Subtitle={modalText} open={open} setOpen={setOpen} onOk={() => console.log('Form submitted!')} onCancel={() => console.log('Modal cancelled')} />
            {showForm ? (
                // <Features Back={Backhandle} />
                ""
            ) : (
                // Render the table when not showing the form
                <>
                    <div className={style.Route}>
                        <h5>Transactions</h5>
                        <div className={style.btns}>
                            <Button
                                type="primary"
                                onClick={handleExport}
                                className={style.createBtn2}
                            >
                                <CiExport />
                                Data Export
                            </Button>
                            {/* <Upload {...uploadProps} >
                                <Button type="primary" className={style.createBtn}>
                                    <CiImport />
                                    Data Import
                                </Button>
                            </Upload> */}
                        </div>
                    </div>
                    <div className={style.container}>
                        <Space className={style.SearchTable}>
                            <div className={style.SearchBar}>
                                <Input
                                    placeholder="Search..."
                                    prefix={<CiSearch size={20} />}
                                    onChange={(e) => onSearch(e.target.value)}
                                    style={{ width: 200 }}
                                    className={style.inputSearch}
                                />
                                <Select
                                    allowClear
                                    placeholder="Filter by file"
                                    style={{ width: 200 }}
                                    loading={loadingText}
                                    onChange={(value: number | undefined) => {
                                        setLoadingText(true);
                                        setFilters(prev => ({ ...prev, fileId: value }));
                                        setCurrentPage(1);
                                    }}
                                    options={uploadedFiles.map(f => ({ label: f.name, value: f.id }))}
                                />
                                <Dropdown
                                    menu={{ items }}
                                    trigger={['click']}
                                >
                                    <SettingOutlined className={style.tableSettings} />
                                </Dropdown>
                            </div>
                        </Space>
                        <Table
                            loading={loadingText}
                            columns={filteredColumns}
                            dataSource={filteredData}
                            pagination={false}
                            rowSelection={{ type: 'checkbox' }}
                            size="small"
                        />
                        <Pagination
                            align="end"
                            showTotal={(total) => `Total ${total} items`}
                            current={currentPage}
                            total={total}
                            pageSize={pageSize}
                            pageSizeOptions={[9, 18, 36, 72]}
                            showSizeChanger
                            onChange={(page, newSize) => {
                                setCurrentPage(page);
                                if (newSize !== pageSize) {
                                    setPageSize(newSize);
                                    setCurrentPage(1); 
                                }
                            }}
                        />
                    </div>
                </>
            )
            }
        </div >
    );
};


function mapStateToProps(state: any) {
    return {
        Transaction_Red: state.Transaction_Red
    }
}

export default connect(mapStateToProps, Action)(MultiViewTable)